import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getAwaitingList } from 'services/todoList';

const getAwaitingListKey = () => {
  return ['workflow', 'get-waiting-for-approve-list'];
};

export const useAwaitingListQuery = (props) => {
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: getAwaitingListKey(),
    queryFn: async () => {
      const response = await getAwaitingList();

      return response?.data;
    },
    ...props,
  });

  const invalidateAwaitingList = () => {
    queryClient.invalidateQueries({
      queryKey: getAwaitingListKey(),
    });
  };

  return { ...query, invalidateAwaitingList };
};
